'use client';

import ErrorPage, {INextErrorPageProps} from '@components/ErrorPage/ErrorPage';
import * as Sentry from '@sentry/nextjs';
import {useTranslations} from 'next-intl';
import {FC, useEffect} from 'react';

const Page500: FC<INextErrorPageProps> = ({error}) => {
    const t = useTranslations('error500');

    useEffect(() => {
        Sentry.captureException(error);
    }, [error]);

    const reload = () => {
        window.location.reload();
    };

    return (
        <ErrorPage
            body={t('body')}
            title="500"
            buttonLabel={t('button')}
            buttonIcon="refresh"
            onClick={reload}
            error={error}
        />
    );
};

export default Page500;
